<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-12 col-md-5">
                      <h1 class="primary-color">Components</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-12 col-md-2">
                      <v-btn class="new-item-btn float-right" block @click="openCreateComponent">
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Create component
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreateComponent"
                  outlined
                  :color="successfullCreateComponent ? 'success' : 'error'"
                  :icon="successfullCreateComponent ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreateComponent }}
                </v-alert>
                <v-alert
                  v-if="messageDeleteComponent"
                  outlined
                  :color="successfullDeleteComponent ? 'success' : 'error'"
                  :icon="successfullDeleteComponent ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDeleteComponent }}
                </v-alert>
                <v-alert
                  v-if="messageEditComponent"
                  outlined
                  :color="successfullEditComponent ? 'success' : 'error'"
                  :icon="successfullEditComponent ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageEditComponent }}
                </v-alert>
                <v-data-table
                  :headers="headers"
                  :items="components"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait..."
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openShowDetails(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openEditComponent(item)">
                          <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit component</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openDeleteComponent(item)">
                          <v-icon size="20" color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete component</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messageComponents"
              class="mt-4"
              outlined
              :color="successfullComponents ? 'success' : 'error'"
              :icon="successfullComponents ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageComponents }}
            </v-alert>

            <v-alert
              v-if="messageComponentTypes"
              class="mt-4"
              outlined
              :color="successfullComponentTypes ? 'success' : 'error'"
              :icon="successfullComponentTypes ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageComponentTypes }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createComponentDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="createComponentForm" @submit.prevent="createComponent">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create Component</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="component.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-select
                    v-model="component.type"
                    class="mt-4 py-0 mb-6 no-border-radius"
                    label="Type *"
                    :items="componentTypesCreate"
                    item-text="name"
                    item-value="id"
                    :rules="rules"
                  />
                </v-col>

                <v-col v-if="component.type === 'LIST'" cols="12" class="py-0 mb-2">
                  <p class="information-text">
                    <v-icon size="20" color="primary">mdi-information</v-icon>&nbsp;&nbsp;Please
                    note that the order you define here will be the correct order in which the
                    question is answered.
                  </p>
                </v-col>
                <v-col v-if="component.type === 'VIDEO'" cols="12" class="py-0">
                  <v-text-field
                    v-model="component.videoUrl"
                    class="py-0 mb-6 no-border-radius"
                    label="URL *"
                    :rules="urlRules"
                    dense
                  />
                </v-col>
                <v-col v-if="component.type === 'IFRAME'" cols="12" class="py-0">
                  <v-text-field
                    v-model="component.videoUrl"
                    class="py-0 mb-6 no-border-radius"
                    label="URL *"
                    :rules="urlRules"
                    dense
                  />
                  <v-text-field
                    v-model="component.triggerUrl"
                    class="py-0 mb-6 no-border-radius"
                    label="Trigger URL *"
                    :rules="urlRules"
                    dense
                  />
                </v-col>

                <v-col
                  v-if="
                    component.type === 'TEST' ||
                    component.type === 'LIST' ||
                    component.type === 'LIKERT'
                  "
                  cols="12"
                  class="pt-0"
                >
                  <v-row>
                    <v-col cols="8" class="pt-2">
                      <h6 class="details-subtitles">Steps</h6>
                    </v-col>
                    <v-col cols="4" class="pt-2">
                      <v-btn text class="float-right" color="primary" @click="addStep(component)">
                        <v-icon size="20">mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  v-if="
                    component.type === 'TEST' ||
                    component.type === 'LIST' ||
                    component.type === 'LIKERT'
                  "
                  cols="12"
                  class="py-0"
                >
                  <v-data-table
                    :headers="headersSteps"
                    :items="component.steps"
                    item-class="text-wrap"
                  >
                    <template #[`item.order`]="{ item }">
                      {{ item.order + 1 }}
                    </template>
                    <template #[`item.content`]="{ item }">
                      <v-text-field v-model="item.content" :rules="rules" />
                    </template>
                    <template #[`item.actions`]="{ item }">
                      <v-tooltip top>
                        <template #activator="{ on }">
                          <v-btn icon v-on="on" @click="deleteStep(component, item)">
                            <v-icon size="20" color="error">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete step</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-alert
                v-if="messageCreateComponentInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullCreateComponentInside ? 'success' : 'error'"
                :icon="successfullCreateComponentInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageCreateComponentInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreateComponent"> Cancel </v-btn>
            <v-btn v-if="!creatingComponent" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editComponentDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="editComponentForm" @submit.prevent="editComponent">
          <v-card-title class="px-6">
            <h5 class="primary-color">Update Component</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="itemToEdit.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-select
                    v-model="itemToEdit.type"
                    class="py-0 mb-6 no-border-radius"
                    label="Type *"
                    :items="componentTypesUpdate"
                    item-text="name"
                    item-value="id"
                    :rules="rules"
                  />
                </v-col>
                <v-col v-if="itemToEdit.type === 'VIDEO'" cols="12" class="py-0">
                  <v-text-field
                    v-model="itemToEdit.videoUrl"
                    class="py-0 mb-6 no-border-radius"
                    label="URL *"
                    :rules="urlRules"
                    dense
                  />
                </v-col>
                <v-col v-if="itemToEdit.type === 'IFRAME'" cols="12" class="py-0">
                  <v-text-field
                    v-model="itemToEdit.videoUrl"
                    class="py-0 mb-6 no-border-radius"
                    label="URL *"
                    :rules="urlRules"
                    dense
                  />
                  <v-text-field
                    v-model="itemToEdit.triggerUrl"
                    class="py-0 mb-6 no-border-radius"
                    label="Trigger URL *"
                    :rules="urlRules"
                    dense
                  />
                </v-col>

                <v-col
                  v-if="
                    itemToEdit.type === 'TEST' ||
                    itemToEdit.type === 'LIST' ||
                    itemToEdit.type === 'LIKERT'
                  "
                  cols="12"
                  class="pt-0"
                >
                  <v-row>
                    <v-col cols="8" class="pt-4">
                      <h6 class="details-subtitles">Steps</h6>
                    </v-col>
                    <v-col cols="4" class="pt-4">
                      <v-btn
                        text
                        class="float-right"
                        color="primary"
                        @click="addStepEdit(itemToEdit)"
                      >
                        <v-icon size="20">mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  v-if="
                    itemToEdit.type === 'TEST' ||
                    itemToEdit.type === 'LIST' ||
                    itemToEdit.type === 'LIKERT'
                  "
                  cols="12"
                  class="py-0"
                >
                  <v-data-table
                    :headers="headersSteps"
                    :items="itemToEdit.componentSteps"
                    item-class="text-wrap"
                  >
                    <template #[`item.order`]="{ item }">
                      {{ item.order + 1 }}
                    </template>
                    <template #[`item.content`]="{ item }">
                      <v-text-field v-model="item.content" :rules="rules" />
                    </template>
                    <template #[`item.actions`]="{ item }">
                      <v-btn icon v-on="on" @click="deleteStepEdit(itemToEdit, item)">
                        <v-icon size="20" color="error">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>

              <v-alert
                v-if="messageEditComponentInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullEditComponentInside ? 'success' : 'error'"
                :icon="successfullEditComponentInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageEditComponentInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="editComponentDialog = false"> Cancel </v-btn>
            <v-btn v-if="!editingComponent" type="submit" class="ok-modal"> Update </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteComponentDialog" max-width="500">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete Component</h5>
        </v-card-title>
        <v-card-text class="mt-4 pb-0 px-6">
          <p class="mb-0">
            Do you really want to delete the selected component? <br />
            If so, press Confirm.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deleteComponentDialog = false"> Cancel </v-btn>

          <template v-if="!deletingComponent">
            <v-btn class="ok-modal" @click="deleteComponent"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deleteComponent">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDetailsComponentDialog" max-width="600">
      <v-card>
        <v-form ref="detailsComponentForm">
          <v-card-title class="px-6">
            <h5 class="primary-color">Details</h5>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Name:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.name }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Type:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.type }}</p>
                </v-col>
              </v-row>
              <v-row v-if="itemToShow.type === 'VIDEO'">
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">URL:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.videoUrl }}</p>
                </v-col>
              </v-row>
              <v-row v-if="itemToShow.type === 'IFRAME'">
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">URL:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.videoUrl }}</p>
                </v-col>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Trigger URL:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.triggerUrl }}</p>
                </v-col>
              </v-row>
              <template
                v-if="
                  itemToShow.type === 'TEST' ||
                  itemToShow.type === 'LIST' ||
                  itemToShow.type === 'LIKERT'
                "
              >
                <v-row v-if="itemToShow.steps !== undefined && itemToShow.steps.length == 0">
                  <v-col cols="3">
                    <h6 class="details-subtitles primary-color">Steps:</h6>
                  </v-col>
                  <v-col cols="9">
                    <p class="mb-0">Component with no associated steps</p>
                  </v-col>
                </v-row>

                <v-row v-else>
                  <v-col cols="12" class="pb-0">
                    <h6 class="details-subtitles primary-color">Steps:</h6>
                  </v-col>
                  <v-col cols="12" class="py-0 mt-2">
                    <v-data-table
                      :headers="headersDetails"
                      :items="itemToShow.componentSteps"
                      item-key="itemToShow.id"
                      item-class="text-wrap"
                    >
                      <template #[`item.order`]="{ item }">
                        {{ item.order + 1 }}
                      </template></v-data-table
                    >
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="showDetailsComponentDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ComponentsDataService from '@/services/ComponentsDataService';

export default {
  name: 'ComponentsList',
  data() {
    return {
      components: [],
      successfullComponents: false,
      messageComponents: '',
      componentTypesCreate: [],
      componentTypesUpdate: [],
      successfullComponentTypes: false,
      messageComponentTypes: '',
      loading: false,
      successfullCreateComponent: false,
      messageCreateComponent: '',
      successfullCreateComponentInside: false,
      messageCreateComponentInside: '',
      successfullEditComponent: false,
      messageEditComponent: '',
      successfullEditComponentInside: false,
      messageEditComponentInside: '',
      successfullDeleteComponent: false,
      messageDeleteComponent: '',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Created at', value: 'createdAt', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      component: {
        name: '',
        type: '',
        videoUrl: null,
        triggerUrl: null,
        steps: [],
      },
      rules: [(v) => !!v || 'Required field'],
      urlRules: [
        (v) => !!v || 'Required field',
        (v) =>
          /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(v) ||
          'Invalid URL format',
      ],
      createComponentDialog: false,
      creatingComponent: false,
      editComponentDialog: false,
      editingComponent: false,
      deleteComponentDialog: false,
      deletingComponent: false,
      itemToEdit: {},
      itemToDelete: {},
      itemToShow: {},
      headersDetails: [
        { text: 'Step', value: 'order', sortable: false },
        { text: 'Content', value: 'content', sortable: false },
      ],
      showDetailsComponentDialog: false,
      headersSteps: [
        { text: 'Step', value: 'order', sortable: false },
        { text: 'Content', value: 'content', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  watch: {
    'itemToEdit.type'(newType, oldType) {
      if (oldType !== undefined) {
        this.itemToEdit.componentSteps = [];
        this.itemToEdit.videoUrl = null;
        this.itemToEdit.triggerUrl = null;
      }
    },
  },
  async mounted() {
    await this.getAllComponentTypes();
    await this.getAllComponents(1);
  },
  methods: {
    getAllComponents(page) {
      this.loading = true;
      this.components = [];

      ComponentsDataService.findAll(page, this.pagination.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.components = response.data.data;

            if (this.components.length !== 0) {
              this.components.forEach((component) => {
                component.componentSteps.sort((a, b) => a.order - b.order);
              });

              this.pagination.page = page;
              this.pagination.totalPages = response.data.links.totalPages || 1;

              this.pagination.totalItems =
                response.data.links.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }

            this.$forceUpdate();
          } else {
            this.successfullComponents = false;
            this.messageComponents =
              'An error has occurred retrieving the list of components. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullComponents = false;
          this.messageComponents =
            'An error has occurred retrieving the list of components. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAllComponents(newPage);
    },
    getAllComponentTypes() {
      this.loading = true;

      ComponentsDataService.findAllComponentTypes().then(
        (response) => {
          if (response.status == 200) {
            const componentTypes = response.data.data.type;

            const tmpComponentTypesCreate = [];
            const tmpComponentTypesUpdate = [];

            componentTypes.forEach((type) => {
              if (type !== 'QUESTION') tmpComponentTypesCreate.push({ id: type, name: type });

              tmpComponentTypesUpdate.push({ id: type, name: type });
            });

            this.componentTypesCreate = tmpComponentTypesCreate;
            this.componentTypesUpdate = tmpComponentTypesUpdate;
          } else {
            this.successfullComponentTypes = false;
            this.messageComponentTypes =
              'An error has occurred retrieving the list of component types. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullComponentTypes = false;
          this.messageComponentTypes =
            'An error has occurred retrieving the list of component types. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    openCreateComponent() {
      this.createComponentDialog = true;
    },
    addStep(component) {
      component.steps.push({
        content: '',
        order: component.steps.length,
      });
    },
    deleteStep(component, step) {
      component.steps.splice(step.order, 1);

      for (let i = 0; i < component.steps.length; i++) {
        component.steps[i].order = i;
      }
    },
    createComponent() {
      this.successfullCreateComponent = true;
      this.messageCreateComponent = '';

      if (this.$refs.createComponentForm.validate()) {
        this.creatingComponent = true;

        if (this.component.componentTypeId !== null) {
          if (this.component.type === 'VIDEO') {
            this.component.steps = [{ content: this.component.videoUrl, order: 0 }];
          }

          if (this.component.type === 'IFRAME') {
            this.component.steps = [
              {
                content: this.component.videoUrl + '|||' + this.component.triggerUrl,
                order: 0,
              },
            ];
          }

          if (
            this.component.type === 'TEST' ||
            this.component.type === 'LIST' ||
            this.component.type === 'LIKERT'
          ) {
            if (this.component.steps.length === 0) {
              this.successfullCreateComponentInside = false;
              setTimeout(() => {
                this.messageCreateComponentInside =
                  'Please, add at least one step to the component.';
              }, 10);

              this.creatingComponent = false;
              return;
            } else {
              this.component.videoUrl = null;
              this.component.triggerUrl = null;
            }
          }

          ComponentsDataService.create(this.component).then(
            (response) => {
              if (response.status == 201) {
                this.getAllComponents(1);

                this.messageCreateComponent = '';
                this.successfullCreateComponent = true;

                setTimeout(() => {
                  this.messageCreateComponent = 'Component successfully created.';
                }, 10);
              } else {
                this.messageCreateComponent = '';
                this.successfullCreateComponent = true;

                setTimeout(() => {
                  this.messageCreateComponent =
                    'An error has occurred creating the component. Please, try again later.';
                }, 10);
              }

              this.createComponentDialog = false;
              this.creatingComponent = false;
              this.component = {
                name: '',
                type: '',
                videoUrl: null,
                triggerUrl: null,
                steps: [],
              };
            },
            (error) => {
              this.messageCreateComponentInside = '';
              this.messageCreateComponent = '';

              if (error.response.status === 409) {
                this.successfullCreateComponentInside = false;

                setTimeout(() => {
                  this.messageCreateComponentInside =
                    'Component already in use. Please, change its name.';
                }, 10);
              } else if (error.response.status === 401 || error.response.status === 403) {
                localStorage.removeItem('user');
                this.$router.push('/');
              } else {
                this.successfullCreateComponent = false;

                setTimeout(() => {
                  this.messageCreateComponent =
                    'An error has occurred creating the component. Please, try again later.';
                }, 10);

                this.createComponentDialog = false;
                this.component = {
                  name: '',
                  type: '',
                  videoUrl: null,
                  triggerUrl: null,
                  steps: [],
                };
              }

              console.error(
                (error.response && error.response.data) || error.message || error.toString()
              );

              this.creatingComponent = false;
            }
          );
        } else {
          this.successfullCreateComponentInside = false;
          setTimeout(() => {
            this.messageCreateComponentInside = 'Please, select a type for the component.';
          }, 10);

          this.creatingComponent = false;
        }
      }
    },
    cancelCreateComponent() {
      this.createComponentDialog = false;
      this.component = {
        name: '',
        type: '',
        videoUrl: null,
        triggerUrl: null,
        steps: [],
      };
    },
    openEditComponent(component) {
      this.itemToEdit = { ...component };
      if (this.itemToEdit.type === 'VIDEO') {
        this.itemToEdit.videoUrl = this.itemToEdit.componentSteps[0].content;
      } else if (this.itemToEdit.type === 'IFRAME') {
        this.itemToEdit.videoUrl = this.itemToEdit.componentSteps[0].content.split('|||')[0];
        this.itemToEdit.triggerUrl = this.itemToEdit.componentSteps[0].content.split('|||')[1];
      } else {
        this.itemToEdit.componentSteps.forEach((step, index) => {
          step.order = index;
        });
      }
      this.editComponentDialog = true;
    },
    addStepEdit(component) {
      component.componentSteps.push({
        content: '',
        order: component.componentSteps.length,
      });
    },
    deleteStepEdit(component, step) {
      component.componentSteps.splice(step.order, 1);

      for (let i = 0; i < component.componentSteps.length; i++) {
        component.componentSteps[i].order = i;
      }
    },
    editComponent() {
      this.successfullEditComponent = true;

      if (this.$refs.editComponentForm.validate()) {
        this.editingComponent = true;

        if (this.itemToEdit.type === 'VIDEO') {
          this.itemToEdit.componentSteps = [
            {
              content: this.itemToEdit.videoUrl,
              order: 0,
            },
          ];
        }

        if (this.itemToEdit.type === 'IFRAME') {
          this.itemToEdit.componentSteps = [
            {
              content: this.itemToEdit.videoUrl + '|||' + this.itemToEdit.triggerUrl,
              order: 0,
            },
          ];
        }

        if (this.itemToEdit.componentSteps.length === 0) {
          this.successfullEditComponentInside = false;
          setTimeout(() => {
            this.messageEditComponentInside = 'Please, add at least one step to the component.';
          }, 10);

          this.editingComponent = false;
          return;
        } else {
          this.component.videoUrl = null;
          this.component.triggerUrl = null;
        }

        this.itemToEdit.steps = this.itemToEdit.componentSteps;
        delete this.itemToEdit.componentSteps;

        ComponentsDataService.update(this.itemToEdit).then(
          (response) => {
            if (response.status == 204) {
              setTimeout(() => {
                this.getAllComponents(1);
              }, 100);

              this.messageEditComponent = '';
              this.successfullEditComponent = true;

              setTimeout(() => {
                this.messageEditComponent = 'Component successfully updated.';
              }, 10);
              this.$forceUpdate();
            } else {
              this.messageEditComponent = '';
              this.successfullEditComponent = true;

              setTimeout(() => {
                this.messageEditComponent =
                  'An error has occurred updating the component. Please, try again later.';
              }, 10);
            }

            this.editComponentDialog = false;
            this.editingComponent = false;
            this.itemToEdit = {};
          },
          (error) => {
            this.messageEditComponentInside = '';
            this.messageEditComponent = '';

            if (error.response.status === 409) {
              this.successfullEditComponentInside = false;

              setTimeout(() => {
                this.messageEditComponentInside =
                  'Component already in use. Please, change its name.';
              }, 10);
            } else if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullEditComponent = false;

              setTimeout(() => {
                this.messageEditComponent =
                  'An error has occurred updating the component. Please, try again later.';
              }, 10);

              this.editComponentDialog = false;
              this.itemToEdit = {};
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.editingComponent = false;
          }
        );
      }
    },
    openDeleteComponent(component) {
      this.itemToDelete = { ...component };
      this.deleteComponentDialog = true;
    },
    deleteComponent() {
      if (this.itemToDelete.id !== undefined) {
        this.deletingComponent = true;

        ComponentsDataService.delete(this.itemToDelete.id).then(
          (response) => {
            if (response.status == 204) {
              this.getAllComponents(1);
              this.messageDeleteComponent = '';
              this.successfullDeleteComponent = true;

              setTimeout(() => {
                this.messageDeleteComponent = 'Component successfully deleted.';
              }, 10);
            } else {
              this.messageDeleteComponent = '';
              this.successfullDeleteComponent = false;

              setTimeout(() => {
                this.messageDeleteComponent =
                  'An error has occurred deleting the component. Please, try again later.';
              }, 10);
            }

            this.deleteComponentDialog = false;
            this.deletingComponent = false;
            this.itemToDelete = {};
          },
          (error) => {
            this.messageDeleteComponent = '';
            this.successfullDeleteComponent = false;

            setTimeout(() => {
              this.messageDeleteComponent =
                'An error has occurred deleting the component. Please, try again later.';
            }, 10);

            this.deleteComponentDialog = false;
            this.itemToDelete = {};

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.deletingComponent = false;
          }
        );
      } else {
        this.messageDeleteComponent = '';
        this.successfullDeleteComponent = false;

        setTimeout(() => {
          this.messageDeleteComponent =
            'An error has occurred deleting the component. Please, try again later.';
        }, 10);

        this.deleteComponentDialog = false;
        this.itemToDelete = {};
      }
    },
    openShowDetails(component) {
      this.itemToShow = { ...component };

      if (this.itemToShow.type === 'VIDEO') {
        this.itemToShow.videoUrl = this.itemToShow.componentSteps[0].content;
      } else if (this.itemToShow.type === 'IFRAME') {
        this.itemToShow.videoUrl = this.itemToShow.componentSteps[0].content.split('|||')[0];
        this.itemToShow.triggerUrl = this.itemToShow.componentSteps[0].content.split('|||')[1];
      } else {
        this.itemToShow.componentSteps.forEach((step, index) => {
          step.order = index;
        });
      }
      this.showDetailsComponentDialog = true;
    },
  },
};
</script>
